import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { EventPriceTier } from '@radevents/shared';

/**
 * Preisstufen im Event-Formular: Bezeichnung und letzter Tag. Ohne Betrag (V179): gefragt ist
 * nur, bis wann es günstiger ist.
 */
export interface PriceTierFormRow {
  label: string;
  validUntil: string;
}

export const priceTierRowsFromTiers = (tiers?: EventPriceTier[] | null): PriceTierFormRow[] =>
  (tiers ?? []).map(t => ({ label: t.label ?? '', validUntil: t.validUntil }));

/** Zeilen ohne Datum fallen weg — eine Stufe ohne Frist sagt nichts. */
export const toPriceTiers = (rows: PriceTierFormRow[]): EventPriceTier[] =>
  rows
    .filter(r => r.validUntil)
    .map(r => ({ label: r.label.trim() || null, validUntil: r.validUntil }));

const PriceTiersEditor: React.FC<{
  rows: PriceTierFormRow[];
  onChange: (rows: PriceTierFormRow[]) => void;
  inputStyle: React.CSSProperties;
}> = ({ rows, onChange, inputStyle }) => {
  const update = (i: number, patch: Partial<PriceTierFormRow>) =>
    onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  return (
    <div className="sm:col-span-2">
      <label className="block text-xs font-semibold mb-1" style={{ color: 'var(--form-label)' }}>
        Preisstufen <span className="font-normal opacity-70">(optional, je Stufe der letzte Tag, bevor es teurer wird)</span>
      </label>
      <div className="grid gap-2">
        {rows.map((r, i) => (
          <div key={i} className="pt-edit-row">
            <input value={r.label} onChange={e => update(i, { label: e.target.value })} aria-label="Bezeichnung"
              placeholder="z. B. Frühbucher" maxLength={80} className="w-full px-3 py-2 rounded-lg text-sm" style={inputStyle} />
            <input type="date" value={r.validUntil} onChange={e => update(i, { validUntil: e.target.value })}
              aria-label="Gültig bis" title="Gültig bis (letzter Tag)" className="w-full px-3 py-2 rounded-lg text-sm" style={inputStyle} />
            <button type="button" onClick={() => onChange(rows.filter((_, j) => j !== i))} aria-label="Preisstufe entfernen"
              className="inline-flex items-center justify-center rounded-lg" style={{ border: '1px solid var(--input-border)', color: 'var(--text-secondary)' }}>
              <Trash2 size={15} aria-hidden />
            </button>
          </div>
        ))}
        <button type="button" onClick={() => onChange([...rows, { label: '', validUntil: '' }])}
          className="inline-flex items-center gap-1 text-sm font-semibold" style={{ color: '#922C57', justifySelf: 'start' }}>
          <Plus size={15} aria-hidden /> Preisstufe hinzufügen
        </button>
      </div>
    </div>
  );
};

export default PriceTiersEditor;
